import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.scss';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

if(!process.env.REACT_APP_TITLE.includes('Dev')){
  // Remove Logs if environment not dev
  console.log = function(){}
}

const {
  aws_project_region,
  aws_cognito_identity_pool_id,
  aws_cognito_region,
  aws_user_pools_id,
  aws_user_pools_web_client_id,
  oauth,
} = awsExports;

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: aws_cognito_identity_pool_id,
      userPoolId: aws_user_pools_id,
      userPoolClientId: aws_user_pools_web_client_id,
      loginWith: { oauth: oauth || {} },
    },
  },
  API: {
    REST: {
      SECURITY_SERVICE: {
        endpoint: process.env.REACT_APP_SECURITY_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
      USER_SERVICE: {
        endpoint: process.env.REACT_APP_USER_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
      LISTING_SERVICE: {
        endpoint: process.env.REACT_APP_LISTING_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
      SECONDARY_MARKET_SERVICE: {
        endpoint: process.env.REACT_APP_SECONDARY_MARKET_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
      REPORTS_SERVICE: {
        endpoint: process.env.REACT_APP_REPORTS_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
      LISTING_CALENDAR_SERVICE: {
        endpoint: process.env.REACT_APP_LISTING_CALENDAR_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
      NOTIFICATION_SERVICE: {
        endpoint: process.env.REACT_APP_NOTIFICATION_SERVICE_ENDPOINT,
        region: aws_project_region,
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// Strict mode causes white screen on dev unless reload - IAN
// TODO
// Investigate strict mode white screen
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
